import { createFileRoute } from '@tanstack/react-router'
import { loaderSeason } from '~/features/compensation/queries'
import { AccountsPage } from '~/features/finance/AccountsPage'
import { NoFinanceAccess } from '~/features/finance/parts'
import { accountsQuery } from '~/features/finance/queries'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/finanzen/konten')({
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (s?.canRead) await context.queryClient.ensureQueryData(accountsQuery())
  },
  component: function Konten() {
    return useCan()('finance.read') ? <AccountsPage /> : <NoFinanceAccess title="Finanzen" />
  },
})
